export default "__VITE_ASSET__DRM6Iv02__"